import { motion } from "framer-motion";
import { ARTWORK } from "@/components/site/siteData";

export const Screen = ({ page, children, testId }) => {
  const art = ARTWORK[page];
  return (
    <div className="screen" style={{ aspectRatio: art.ratio }} data-testid={testId || `screen-${page}`}>
      <motion.img
        src={art.src}
        alt={art.alt}
        className="screen-art"
        initial={{ scale: 1.035, filter: "brightness(0.75)" }}
        animate={{ scale: 1, filter: "brightness(1)" }}
        transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
      />
      {children}
    </div>
  );
};

export const Hotspot = ({ x, y, w, h, label, onClick, nav, testId }) => (
  <button
    type="button"
    className={`hotspot${nav ? " nav-link" : ""}`}
    style={{ left: `${x}%`, top: `${y}%`, width: `${w}%`, height: `${h}%` }}
    aria-label={label}
    title={label}
    onClick={onClick}
    data-testid={testId}
  />
);

export const Spot = ({ box, className = "", children, style, ...rest }) => (
  <div
    className={`ov ${className}`}
    style={{ left: `${box[0]}%`, top: `${box[1]}%`, width: `${box[2]}%`, height: `${box[3]}%`, ...style }}
    {...rest}
  >
    {children}
  </div>
);
